import "core-js/modules/es6.promise";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es7.promise.finally";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "regenerator-runtime/runtime";
import "core-js/modules/es6.string.starts-with";
import "core-js/modules/es6.array.find";
import "core-js/modules/web.dom.iterable";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ApiService from '../../services/apiService';
import { mapMutations, mapState, mapGetters } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';
import { themesMixin } from '../../utils/themes';
import drawerLinksMixin from './drawerLinks';
export default {
  name: 'CoreDrawer',
  mixins: [themesMixin, drawerLinksMixin],
  data: function data() {
    return {
      cleanedLinks: [],
      userHasKeys: false,
      sidebarLogo: '',
      sidebarLogoOrientation: '',
      sidebarLogoByline: ''
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState('app', ['image', 'color', 'UiTheme', 'miniVariant', 'themes', 'sidebarIconLink'])), mapGetters({
    sessionUserId: 'authentication/userId'
  })), {}, {
    inputValue: {
      get: function get() {
        return this.$store.state.app.drawer;
      },
      set: function set(val) {
        this.setDrawer(val);
      }
    },
    positionTop: function positionTop() {
      return [this.$store.state.app.bannerHeight ? {
        top: "".concat(this.$store.state.app.bannerHeight, "px")
      } : {
        top: '0px'
      }];
    },
    sidebarOverlayGradiant: function sidebarOverlayGradiant() {
      if (this.$store.state.app.UiTheme) {
        // D-SUITE return 'to top left, rgba(6, 20, 3, 1.0), rgba(6, 20, 3, 1.0)';
        return 'to top left, rgba(60, 60, 60, 0.9), rgba(0, 0, 0, 0.9)';
      }

      return 'to top left, rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 1.0)';
    },
    responsive: function responsive() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    drawerLinksWithPermissions: function drawerLinksWithPermissions() {
      var _this = this;

      var drawerLinks = cloneDeep(this.links); // if back-end side drawer links are available from the theming, use those instead

      if ((this.$store.state.app.drawerLinks || []).length) {
        drawerLinks = cloneDeep(this.$store.state.app.drawerLinks);
      }

      var replacePlaceholders = function replacePlaceholders(links) {
        links.forEach(function (link) {
          if (link.to === 'GRAFANA_PLACEHOLDER') {
            link.to = _this.$store.state.app.grafanaUrl;
          }

          if (link.to === 'FIREFLY_PLACEHOLDER') {
            link.to = _this.$store.state.app.fireflyUrl;
          }

          if (link.children) {
            replacePlaceholders(link.children);
          }
        });
      };

      replacePlaceholders(drawerLinks); // pull the route-permissions from the vue router for each drawer link

      var addPermissions = function addPermissions(links) {
        links.forEach(function (link) {
          if (link.to) {
            var routerPath = _this.$router.options.routes.find(function (route) {
              return route.path === link.to;
            }); // this is a "local" link, but no router-path was found
            // this probably means the flag was filtered out via excludeEnv


            if (!routerPath && link.to.startsWith('/')) {
              link.permissions = 'NOT_AVAILABLE';
            } else if (!link.permissions) {
              link.permissions = get(routerPath, 'meta.permissions', link.permissions);
            }
          }

          if (link.children) {
            addPermissions(link.children);
          }
        });
      };

      addPermissions(drawerLinks);
      return drawerLinks;
    }
  }),
  watch: {
    UiTheme: function UiTheme() {
      this.lookupSidebarLogo();
    }
  },
  mounted: function mounted() {
    this.loadUserKeys();
    this.checkDrawerPermissions();
    this.lookupSidebarLogo();
  },
  methods: _objectSpread(_objectSpread({}, mapMutations('app', ['setDrawer', 'toggleDrawer'])), {}, {
    lookupSidebarLogo: function lookupSidebarLogo() {
      var mode = this.UiTheme ? 'dark' : 'light';
      this.sidebarLogo = this.themes[mode].logo;
      this.sidebarLogoOrientation = this.themes[mode].orientation;

      if (this.themes[mode].orientation !== 'portrait' && this.themes[mode].orientation !== 'square') {
        this.sidebarLogoOrientation = 'landscape';
      }

      this.sidebarLogoByline = this.themes[mode].byline;
    },
    checkDrawerPermissions: function () {
      var _checkDrawerPermissions = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.cleanedLinks = this.filterLinksByPermissions(this.drawerLinksWithPermissions, this.$store.state.app.permissions);
                this.cleanedLinks = this.filterLinksByFeatureFlags(this.cleanedLinks); // after filtering by permission get rid of categories that have no links

                this.cleanedLinks = this.cleanedLinks.filter(function (link, idx, array) {
                  return !(link.category && (array[idx + 1] || {}).category);
                }); // trigger a UI-refresh

                this.cleanedLinks = cloneDeep(this.cleanedLinks);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function checkDrawerPermissions() {
        return _checkDrawerPermissions.apply(this, arguments);
      }

      return checkDrawerPermissions;
    }(),
    filterLinksByFeatureFlags: function filterLinksByFeatureFlags(links) {
      var _this2 = this;

      return cloneDeep(links).filter(function (link) {
        if (link.children) {
          link.children = _this2.filterLinksByFeatureFlags(link.children);
        }

        if (link.featureflag) {
          if (link.featureflag.startsWith('!')) {
            return !_this2.$store.state.app.featureFlags[link.featureflag.slice(1)];
          }

          return _this2.$store.state.app.featureFlags[link.featureflag];
        }

        return true;
      });
    },
    filterLinksByPermissions: function filterLinksByPermissions(links, userPermissions) {
      var _this3 = this;

      return cloneDeep(links).filter(function (link) {
        if (link.children) {
          link.children = _this3.filterLinksByPermissions(link.children, userPermissions); // no need to display empty groups

          if (get(link, 'children', []).length === 0 && !link.to) {
            return false;
          }
        }

        var preconditions = true;
        link.active = false;

        if (link.conditions) {
          preconditions = Object.keys(link.conditions).every(function (key) {
            return _this3[key] === link.conditions[key];
          });
        }

        if (link.permissions) {
          var checkPermissions = function checkPermissions(permissionSet) {
            if (permissionSet === 'NOT_AVAILABLE') {
              return false;
            } // {
            //   or: [
            //     {and: [
            //       { subject: 'DigitalTwin', action: 'manage' },
            //       { subject: 'AutoID', action: 'read', inverted: true }
            //     ]},
            //     { subject: 'all', action: 'manage' }
            //   ]
            // }


            if (permissionSet.or && Array.isArray(permissionSet.or)) {
              return permissionSet.or.find(function (permission) {
                return checkPermissions(permission);
              });
            } else if (permissionSet.and && Array.isArray(permissionSet.and)) {
              return permissionSet.and.every(function (permission) {
                return checkPermissions(permission);
              });
            }

            var hasPermission = userPermissions["".concat(permissionSet.subject, ".").concat(permissionSet.action)];
            return hasPermission === !permissionSet.inverted;
          };

          return preconditions && checkPermissions(link.permissions);
        }

        return preconditions;
      });
    },
    // UTILS
    // helper methods that retrieve additional data for custom conditions
    loadUserKeys: function loadUserKeys() {
      var _this4 = this;

      var canUseKeys = this.$store.state.app.permissions['IsFmAccess.write'] || this.$store.state.app.permissions['IsFmAccess.manage'] || this.$store.state.app.permissions['all.manage'];

      if (canUseKeys) {
        ApiService.isFmAccessFetchByUserId(this.sessionUserId).then(function (data) {
          _this4.userHasKeys = data.length > 0;
        }).catch(function () {
          _this4.userHasKeys = false;
        }).finally(function () {
          _this4.checkDrawerPermissions();
        });
      } else {
        this.userHasKeys = false;
        this.checkDrawerPermissions();
      }
    }
  })
};